"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const roomFilterState_1 = require("@/room/room_main/MainRooms/roomFilterState");
const isDataFetchingState_1 = __importDefault(require("@/common/functions/useIsDataFetching/isDataFetchingState"));
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const _1 = require(".");
function default_1() {
    const [fondsData, setFondsData] = (0, react_1.useState)([]);
    const fondsDataAvailable = !!fondsData.length;
    const [{ id: categoryFilterId }, setCategoryFilter] = (0, recoil_1.useRecoilState)(roomFilterState_1.categoryFilterState);
    const [roomTypeFilter, setRoomTypeFilter] = (0, recoil_1.useRecoilState)(roomFilterState_1.roomTypeFilterState);
    const isRoomTypeRecent = roomTypeFilter === '';
    const { scrollDiv, setScrollDiv, centerTarget } = (0, functions_1.useHorizontalDragScroll)();
    (0, react_1.useEffect)(() => {
        if (categoryFilterId) {
            centerTarget(document.querySelector('#selected_main_category'));
        }
    }, [categoryFilterId, scrollDiv]);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const scrollToRecentMainRooms = () => {
        if (scrollDiv) {
            const headerHeight = maxWidth768 ? 0 : 50;
            const scrollDivOffsetTop = scrollDiv.offsetTop - headerHeight;
            window.setTimeout(() => window.scrollTo({ behavior: 'smooth', top: scrollDivOffsetTop }), 300);
        }
    };
    const updateCategoryAndShowRecentMainRooms = ({ isSelected, categoryId, categoryName, }) => {
        if (!isSelected) {
            setCategoryFilter({ id: categoryId, name: categoryName });
            setRoomTypeFilter('');
        }
        scrollToRecentMainRooms();
    };
    const moveScrollbarThumb = () => {
        const scrollbarThumb = document.getElementById('fonds_scrollbar_thumb');
        if (!!scrollbarThumb && !!scrollDiv) {
            const trackWidth = scrollDiv.scrollWidth - scrollDiv.clientWidth;
            const thumbMargin = Math.round((scrollDiv.scrollLeft / trackWidth) * 40);
            scrollbarThumb.style.marginLeft = `${thumbMargin}px`;
        }
    };
    const switchScrollbarDisplay = () => {
        const scrollbarTrack = document.getElementById('fonds_scrollbar_track');
        if (!!scrollDiv && !!scrollbarTrack) {
            if (scrollDiv.scrollWidth <= scrollDiv.clientWidth) {
                scrollbarTrack.setAttribute('style', 'display: none;');
            }
            else {
                scrollbarTrack.removeAttribute('style');
                moveScrollbarThumb();
            }
        }
    };
    (0, react_1.useEffect)(() => {
        if (!fondsDataAvailable) {
            (0, api_1.getData)('/api/v1/fond/list')
                .then(res => setFondsData(res.data.result))
                .catch(() => { });
        }
        else if (!!scrollDiv) {
            switchScrollbarDisplay();
            window.addEventListener('resize', switchScrollbarDisplay);
            return () => {
                window.removeEventListener('resize', switchScrollbarDisplay);
            };
        }
    }, [fondsDataAvailable, scrollDiv]);
    const isDataFetching = (0, recoil_1.useRecoilValue)(isDataFetchingState_1.default);
    if (!fondsDataAvailable)
        return (0, jsx_runtime_1.jsx)(_1.MainFondsSkeleton, {});
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ ref: setScrollDiv, onScroll: moveScrollbarThumb, className: maxWidth768 ? 'horizontal_drag_scroll no_scroll_bar' : undefined, css: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    paddingTop: '8px',
                } }, { children: fondsData.map((fond, index) => {
                    const { id, name: categoryName, img_url } = fond;
                    const categoryId = String(id);
                    const isSelected = isRoomTypeRecent && categoryFilterId === categoryId;
                    const onFondClick = () => {
                        if (!isDataFetching) {
                            updateCategoryAndShowRecentMainRooms({ isSelected, categoryId, categoryName });
                        }
                    };
                    return ((0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ id: isSelected ? 'selected_main_category' : undefined, onClick: onFondClick, sx: {
                            flexDirection: 'column',
                            alignItems: 'center',
                            rowGap: '4px',
                            minWidth: maxWidth768 ? '72px' : 'unset',
                            padding: '0 4px 8px',
                            bgcolor: 'var(--white) !important',
                            color: isSelected ? 'var(--primary-dark)' : 'var(--gray-80)',
                            '.MuiTouchRipple-root': {
                                aspectRatio: '1 / 1',
                                inset: '0 4px',
                                maxWidth: '48px',
                                margin: '0 auto',
                                borderRadius: '8px',
                            },
                        } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                                    position: 'relative',
                                    width: '100%',
                                    maxWidth: '48px',
                                    maxHeight: '48px',
                                    '&:after': isSelected &&
                                        (0, functions_1.afterImgWrapper)({
                                            border: '1px solid var(--primary-dark)',
                                            borderRadius: '8px',
                                        }),
                                } }, { children: (0, jsx_runtime_1.jsx)("img", { src: (0, functions_1.getCdnUrl)(img_url) || `${process.env.CDN_URL}/assets/svgs/default_profile.svg`, loading: "lazy", css: {
                                        width: '100%',
                                        height: '100%',
                                        borderRadius: '8px',
                                        objectFit: 'cover',
                                    } }) })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "text_overflow caption2", css: { WebkitLineClamp: 1 } }, { children: categoryName }))] }), `main_fond_${categoryId}_${index}`));
                }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ id: "fonds_scrollbar_track", css: {
                    margin: '5px auto 0',
                    width: '60px',
                    height: '2px',
                    borderRadius: '2px',
                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                } }, { children: (0, jsx_runtime_1.jsx)("div", { id: "fonds_scrollbar_thumb", css: {
                        width: '20px',
                        height: '2px',
                        borderRadius: '2px',
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        transition: 'all 0.1s ease',
                    } }) }))] }));
}
exports.default = default_1;
